import { Box, Step, StepIconProps, Stepper } from '@mui/material';
import { CustomStepLabel } from '../AddNewTemplate.Styled';
import { StepIconComponent } from '../../StepIconComponent';

interface StepsProps {
  activeStep: number;
  steps: string[];
}

const Steps = ({ activeStep, steps }: StepsProps) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      m: '42px auto'
    }}
  >
    <Stepper activeStep={activeStep} sx={{ width: '200px' }}>
      {steps.map((label, index) => (
        <Step key={label}>
          <CustomStepLabel
            StepIconComponent={(props: StepIconProps) =>
              StepIconComponent({
                ...props,
                icon: index + 1,
                active: index === activeStep,
                completed: index < activeStep
              })
            }
          />
        </Step>
      ))}
    </Stepper>
  </Box>
);

export { Steps };
